import BSwitch from './packages/BSwitch'

BSwitch.install = function (Vue) {
    Vue.component(BSwitch.name, BSwitch)
}

export default BSwitch
